//@ts-check

class CSortBy extends HTMLElement {
  constructor() {
    super()

    this.btn = this.querySelector('[data-toggle-sort-by]')
    this.content = this.querySelector('[data-content-sort-by]')
    this.values = [...this.querySelectorAll('[data-value-sort-by]')]
    //@ts-ignore
    this.Shopify = window.Shopify

    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  connectedCallback() {
    this.btn?.addEventListener('click', () => {
      const isOpen = this.btn?.classList.contains('is-open')
      if (isOpen) {
        this.close()
      } else {
        this.open()
      }
    })
    this.Shopify.queryParams = {}
    this.preserveExitingQuery()

    this.values.forEach((el) => {
      el.addEventListener('click', () => {
        this.preserveExitingQuery()
        const value = el.getAttribute('value')

        this.Shopify.queryParams.sort_by = value
        location.search = new URLSearchParams(
          this.Shopify.queryParams
        ).toString()
      })
    })
  }

  open() {
    this.btn?.classList.add('is-open')
    this.content?.removeAttribute('hidden')
    document.addEventListener('click', this.handleOutsideClick)
  }

  close() {
    this.btn?.classList.remove('is-open')
    this.content?.setAttribute('hidden', 'true')
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.close()
    }
  }

  preserveExitingQuery() {
    if (location.search.length) {
      var params = location.search.substr(1).split('&')

      for (var i = 0; i < params.length; i++) {
        var keyValue = params[i].split('=')
        if (keyValue.length) {
          this.Shopify.queryParams[decodeURIComponent(keyValue[0])] =
            decodeURIComponent(keyValue[1])
        }
      }
    }
  }

  disconnectedCallback() {
    this.close()
  }
}
if (!customElements.get('c-sort-by')) {
  customElements.define('c-sort-by', CSortBy)
}
